import React, { useEffect, useState } from 'react';
import {
  Box,
  HeadingText,
  GDSStyleObject,
  FormField,
  TextInput,
  Select,
  StackLayout,
  Fieldset,
  Radio,
} from '@leagueplatform/genesis-core';
import {
  isEmpty,
  isNotEmpty,
  isValidDate,
  updateFormData,
  isNoSpace,
} from '../../../helpers';

export function OtherCoveragePolicyHolderInformation(props: any) {
  const { errorHandling, nextButtonClicked, footerToBottom } = props;

  const [dateOfBirthError, setDateOfBirthError] = useState<string>('');

  const [form, setForm] = useState({
    policyHolderName: '',
    policyHolderDob: '',
    policyHolderGender: '',
    policyID: '',
    planNumber: '',
    relationshipToPolicyHolder: '',
  });

  const [errors, setErrors] = useState({
    policyHolderName: false,
    policyHolderDob: false,
    policyHolderGender: false,
    policyID: false,
    relationshipToPolicyHolder: false,
  });

  const formField =
    isEmpty(form.policyHolderName) ||
    isEmpty(form.policyHolderDob) ||
    !isValidDate(form.policyHolderDob) ||
    isEmpty(form.policyHolderGender) ||
    isEmpty(form.policyID) ||
    isEmpty(form.relationshipToPolicyHolder);

  const isValid =
    isNotEmpty(form.policyHolderName) &&
    isNotEmpty(form.policyHolderDob) &&
    isValidDate(form.policyHolderDob) &&
    isNotEmpty(form.policyHolderGender) &&
    isNotEmpty(form.policyID) &&
    isNotEmpty(form.relationshipToPolicyHolder);
  useEffect(() => {
    footerToBottom(false);
  }, [footerToBottom]);
  useEffect(() => {
    if (formField || errors.policyHolderDob) {
      errorHandling(false);

      if (isEmpty(form.policyHolderDob)) {
        setDateOfBirthError("Policy holder's date of birth is required.");
      } else if (!isValidDate(form.policyHolderDob)) {
        setDateOfBirthError('Please enter a valid date of birth.');
      } else {
        setDateOfBirthError('');
      }
    } else {
      errorHandling(true);
    }
  }, [formField, errorHandling, form, errors]);

  useEffect(() => {
    if (nextButtonClicked) {
      if (!isValid) {
        setErrors({
          policyHolderName: isEmpty(form.policyHolderName),
          policyHolderDob:
            isEmpty(form.policyHolderDob) || !isValidDate(form.policyHolderDob),
          policyHolderGender: isEmpty(form.policyHolderGender),
          policyID: isEmpty(form.policyID),
          relationshipToPolicyHolder: isEmpty(form.relationshipToPolicyHolder),
        });
      }
    }
  }, [nextButtonClicked, isValid, form]);

  const updateErrorState = (value: string, id: string) => {
    if (id === 'policyHolderDob') {
      if (isEmpty(value)) {
        setDateOfBirthError("Policy holder's date of birth is required.");
        setErrors((prevState) => ({
          ...prevState,
          policyHolderDob: true,
        }));
      } else if (!isValidDate(value)) {
        setDateOfBirthError('Please enter a valid date of birth.');
        setErrors((prevState) => ({
          ...prevState,
          policyHolderDob: true,
        }));
      } else {
        setDateOfBirthError('');
        setErrors((prevState) => ({
          ...prevState,
          policyHolderDob: false,
        }));
      }
    } else {
      const nextErrorState = {
        ...errors,
        [id]: isEmpty(value),
      };
      setErrors(nextErrorState);
    }
  };

  const onUpdateField = (event: any) => {
    const { value, id } = event.target;
    const nextFormState = {
      ...form,
      [event.target.id]: /^\s/.test(event.target.value)
        ? ''
        : event.target.value,
    };
    setForm(nextFormState);
    updateErrorState(event.target.value, event.target.id);

    if (id === 'policyHolderName') {
      setForm((prevState) => ({
        ...prevState,
        policyHolderName: isNoSpace(value)
          ? ''
          : value?.replace(/[^a-zA-Z0-9 \-']+/gi, ''),
      }));
    }

    if (id === 'policyHolderDob') {
      let dateValue = value;
      if (value.length === 3) {
        if (dateValue[2] === '/') {
          dateValue = value;
        } else {
          dateValue = `${value.substring(0, 2)}/${value.substring(2)}`;
        }
      } else if (value.length === 6) {
        if (dateValue[5] === '/') {
          dateValue = value;
        } else {
          dateValue = `${value.substring(0, 5)}/${value.substring(5)}`;
        }
      } else if (dateValue[dateValue.length - 1] === '/') {
        dateValue = form.policyHolderDob;
      } else {
        dateValue = value;
      }
      setForm((prevState) => ({
        ...prevState,
        policyHolderDob: isNoSpace(dateValue)
          ? ''
          : dateValue.replace(/[^0-9/]+/gi, ''),
      }));
    }

    if (id === 'policyID') {
      setForm((prevState) => ({
        ...prevState,
        policyID: isNoSpace(value) ? '' : value.replace(/[^0-9]+/gi, ''),
      }));
    }

    if (id === 'policyHolderGender-1' || id === 'policyHolderGender-2') {
      setForm((prevState) => ({
        ...prevState,
        policyHolderGender: value,
      }));
      updateErrorState(value, 'policyHolderGender');
    }
  };

  useEffect(() => {
    const pInfo = JSON.parse(sessionStorage.getItem('formData') || '{}');
    if (pInfo) {
      setForm({
        policyHolderName: pInfo?.policyHolderName,
        policyHolderDob: pInfo?.policyHolderDob,
        policyHolderGender: pInfo?.policyHolderGender,
        policyID: pInfo?.policyID,
        planNumber: pInfo?.planNumber,
        relationshipToPolicyHolder: pInfo?.relationshipToPolicyHolder,
      });
    }
  }, []);

  const relationshipOption = () => {
    const relationshipArr = ['Self', 'Spouse/Partner', 'Child', 'Other'];
    const relation = relationshipArr?.map((option: any) => ({
      value: option,
      label: option,
    }));
    return relation;
  };

  const onBlurField = (event: any) => {
    updateErrorState(event.target.value, event.target.id);
  };

  const onKeyPressField = (event: any) => {
    updateErrorState(event.target.value, event.target.id);
  };

  useEffect(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);

  return (
    <StackLayout
      css={
        {
          backgroundColor: 'White',
          maxWidth: '800px',
        } as GDSStyleObject
      }
      horizontalAlignment="center"
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            padding: '$three $two $two $two',
          } as GDSStyleObject
        }
      >
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              padding: '$none $two',
            } as GDSStyleObject
          }
        >
          <HeadingText
            level="1"
            size={{
              '@initial': 'xxl',
              '@mobile': 'xl',
              '@mobileLandscape': 'xl',
              '@tablet': 'xl',
              '@laptop': 'xxl',
              '@desktop': 'xxl',
            }}
          >
            Member Dental Claim Form
          </HeadingText>
        </Box>
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              padding: '$one $two',
              width: '100%',
            } as GDSStyleObject
          }
        >
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'column',
                '@mobile': { width: 'auto' },
                '@desktop': { width: '600px' },
                '@laptop': { width: '600px' },
                '@mobileLandscape': { width: '600px' },
                '@tablet': { width: '600px' },
              } as GDSStyleObject
            }
          >
            <HeadingText
              level="3"
              data-testid="step4"
              size={{
                '@initial': 'xl',
                '@mobile': 'lg',
                '@mobileLandscape': 'lg',
                '@tablet': 'xl',
                '@laptop': 'xl',
                '@desktop': 'xl',
              }}
            >
              Step 4: Other Coverage
            </HeadingText>
          </Box>
          <Box>
            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '$one $none',
                } as GDSStyleObject
              }
            >
              <FormField
                id="policyHolderName"
                label="Name of Policy Holder (Last, First, MI, Suffix)"
                statusIconLabel="Error"
                inputStatus={errors.policyHolderName ? 'error' : undefined}
                statusMessage={
                  errors.policyHolderName
                    ? "Policy holder's name is required."
                    : ''
                }
              >
                <TextInput
                  id="policyHolderName"
                  name="policyHolderName"
                  value={form.policyHolderName}
                  onChange={onUpdateField}
                  onBlur={onBlurField}
                  onKeyPress={onKeyPressField}
                  maxLength={50}
                />
              </FormField>
            </Box>
            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '$one $none',
                } as GDSStyleObject
              }
            >
              <FormField
                id="policyHolderDob"
                label="Date of Birth (MM/DD/YYYY)"
                statusIconLabel="Error"
                inputStatus={errors.policyHolderDob ? 'error' : undefined}
                statusMessage={errors.policyHolderDob ? dateOfBirthError : ''}
              >
                <TextInput
                  id="policyHolderDob"
                  name="policyHolderDob"
                  value={form.policyHolderDob}
                  maxLength={10}
                  onChange={onUpdateField}
                  onBlur={onBlurField}
                  onKeyPress={onKeyPressField}
                />
              </FormField>
            </Box>
            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '$one $none',
                } as GDSStyleObject
              }
            >
              <FormField
                id="policyHolderGender"
                label="Gender"
                statusIconLabel="Error"
                inputStatus={errors.policyHolderGender ? 'error' : undefined}
                statusMessage={
                  errors.policyHolderGender
                    ? 'Policy holder`s gender is required.'
                    : ''
                }
              >
                <Fieldset
                  css={
                    {
                      display: 'flex',
                      maxWidth: '436px',
                    } as GDSStyleObject
                  }
                  legend={undefined}
                >
                  <Radio
                    id="policyHolderGender-1"
                    name={form.policyHolderGender}
                    checked={form.policyHolderGender === 'M'}
                    onChange={onUpdateField}
                    value="M"
                    label="MALE"
                  />
                  <Radio
                    id="policyHolderGender-2"
                    name={form.policyHolderGender}
                    checked={form.policyHolderGender === 'F'}
                    onChange={onUpdateField}
                    value="F"
                    label="FEMALE"
                  />
                </Fieldset>
              </FormField>
            </Box>
            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '$one $none',
                } as GDSStyleObject
              }
            >
              <FormField
                id="policyID"
                label="Policy Holder/Subscriber ID (SSN or ID#)"
                statusIconLabel="Error"
                inputStatus={errors.policyID ? 'error' : undefined}
                statusMessage={
                  errors.policyID
                    ? 'Policy holder/subscriber ID is required.'
                    : ''
                }
              >
                <TextInput
                  name="policyID"
                  value={form.policyID}
                  onChange={onUpdateField}
                  onBlur={onBlurField}
                  onKeyPress={onKeyPressField}
                  maxLength={13}
                />
              </FormField>
            </Box>
            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '$one $none',
                } as GDSStyleObject
              }
            >
              <FormField id="planNumber" label="Plan/Group Number (Optional)">
                <TextInput
                  pattern="[0-9]*"
                  name="planNumber"
                  value={form.planNumber}
                  onChange={onUpdateField}
                  maxLength={50}
                />
              </FormField>
            </Box>
            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '$one $none',
                } as GDSStyleObject
              }
            >
              <FormField
                id="relationshipToPolicyHolder"
                label="Patient’s Relationship to Policy Holder"
                statusIconLabel="Error"
                inputStatus={
                  errors.relationshipToPolicyHolder ? 'error' : undefined
                }
                statusMessage={
                  errors.relationshipToPolicyHolder
                    ? "Patient's relationship to policy holder is required."
                    : ''
                }
              >
                <Select
                  name="relationshipToPolicyHolder"
                  options={relationshipOption()}
                  placeholder="Please Select"
                  id="relationshipToPolicyHolder"
                  value={form.relationshipToPolicyHolder}
                  onChange={onUpdateField}
                  onBlur={onBlurField}
                  onKeyPress={onKeyPressField}
                />
              </FormField>
            </Box>
          </Box>
        </Box>
      </Box>
    </StackLayout>
  );
}
